import { Page } from "../../../common/Page";
import type { AppRouteProps } from "../types";

export function createRootRouteConfig(
  children: AppRouteProps[]
): AppRouteProps {
  return {
    path: "/",
    element: <Page />,
    name: "Root",
    children: [...children],
  };
}
